<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="mt-3 mb-3">
        <div class="card">
          <a id="{{aPanelData.name}}"></a><h1 *ngIf="'' != aPanelData.title" class="card-header" [innerHTML]="app.bypassHtmlSanitizing(aPanelData.title)"></h1>
          <div class="card-body">
            <div [ngSwitch]="aPanelData.type">
              <div *ngSwitchCase="'block'">
                <div [innerHTML]="app.bypassHtmlSanitizing(aPanelData.content)"></div>
              </div>
              <div *ngSwitchDefault>
                <manager-wgt [aWidgetParams]="aPanelData"></manager-wgt>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>